<script>
import { mapActions } from 'vuex';
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter';

export default {
  name: 'LinksFilter',

  extends: BaseAutocompleteSearchRequestFilter,

  methods: {
    ...mapActions('documents_lists', ['getFilteredLinks']),
    getData() {
      return this.getFilteredLinks({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
